import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { PartThresholdBus } from '@app/cp/shared/models/PartThresholdBus';
import { InventoryThresholdOverrideBus } from '../../../shared/models/InventoryThresholdOverrideBus';
import { InventoryReference } from '../../../shared/models/InventoryReference';
import { SaveMode } from '../../../shared/enums/SaveMode';
import { InventoryThresholdOverrideBranchBus } from '../../../shared/models/InventoryThresholdOverrideBranchBus';
import { GItem } from '../../../shared/models/GItem';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'part-branch-thresholds',
    templateUrl: './part-branch-thresholds.component.html',
    styleUrls: ['./part-branch-thresholds.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PartBranchThresholdsComponent extends BaseGridEditLineComponent<InventoryThresholdOverrideBranchBus, null, InventoryService> {

    @Input() inventoryReferenceData: InventoryReference
   
    @Input() branches: GItem[];
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: InventoryService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.className = "InventoryThresholdOverrideBranchBus";
        this.appCode = "InventoryThresholdOverrideBranch";
        this.saveMode = SaveMode.all;
        this.disableCpSearchDialog();
    }

    override createForm() {
        this.editForm = new UntypedFormGroup({
            'companyBranchId': new UntypedFormControl(null, Validators.required),
            'supplierId': new UntypedFormControl(null),
            'supplier': new UntypedFormControl(null),
            'partNbr': new UntypedFormControl(null),
            'minThreshold': new UntypedFormControl(null, Validators.required),
            'maxThreshold': new UntypedFormControl(null, Validators.required),

        });

    }
    supplierCBOChanged(e) {
        this.selectedData.supplierId = e;
        this.selectedData.supplier = this.inventoryReferenceData.getSupplier(e);
        this.editForm.patchValue({
            supplier: this.selectedData.supplier
        });
    }
    override setForm() {
        this.fillSupplierList();
        this.editForm.patchValue({
            companyBranchId: this.selectedData.companyBranchId,
            minThreshold: this.selectedData.minThreshold,
            maxThreshold: this.selectedData.maxThreshold,
            supplierId: this.selectedData.supplierId,
            supplier: this.selectedData.supplier,
            partNbr: this.selectedData.partNbr,
        });
    }

    supplierList = [];

    fillSupplierList() {
        if (this.inventoryReferenceData) {
            this.supplierList = this.inventoryReferenceData?.suppliers.filter(e => e.canSelect === true);

            if (this.selectedData.supplierId) {
                var isFound = this.supplierList.find(e => e.value == this.selectedData.supplierId);

                if (isFound == null) {
                    var toInsert = this.inventoryReferenceData?.suppliers.find(e => e.value == this.selectedData.supplierId);

                    if (toInsert)
                        this.supplierList.push(toInsert);
                }
            }
        }
    }

    suppliersInActive(itemArgs: { dataItem: any, index: number }) {
        if (itemArgs.dataItem == null || itemArgs.dataItem.canSelect == null) return false;
        return !itemArgs.dataItem.canSelect;
    }
}
